import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from 'haba-storefrontlib';
import { HabaCmsProductPageGuard } from './guards/haba-cms-product-page-guard.service';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: null,
        canActivate: [HabaCmsProductPageGuard],
        component: PageLayoutComponent,
        data: { cxRoute: 'product' },
      },
    ]),
  ],
})
export class HabaProductDetailsPageModule {}
